export class ThemeModel {
	primaryColor?: string;
	secondaryColor?: string;
	backgroundColor?: string;
	accentColor?: string;
	actionColor?: string;
	successColor?: string;
	warningColor?: string;
	dangerColor?: string;
	logoCoverColor?: string;
	primaryFontColor?: string;
	secondaryFontColor?: string;
	btnActionColor?: string;
	btnFontActionColor?: string;
	highlightFontColor?: string;
}

export const DEFAULT_THEME: ThemeModel = {
	primaryColor: '#000000',
	secondaryColor: '#6B7280',
	backgroundColor: '#FFFFFF',
	accentColor: '#000000',
	actionColor: '#0032ff',
	successColor: '#16A34A',
	dangerColor: '#F8285A',
	warningColor: '#F59E0B',
	logoCoverColor: '#000000',
	primaryFontColor: '#000000',
	secondaryFontColor: '#6B7280',
	btnActionColor: '#000000',
	btnFontActionColor: '#FFFFFF',
	highlightFontColor: '#FFFFFF',
};
